import { render, staticRenderFns } from "./CofaceAGB.vue?vue&type=template&id=578af96f&"
import script from "./CofaceAGB.vue?vue&type=script&lang=js&"
export * from "./CofaceAGB.vue?vue&type=script&lang=js&"
import style0 from "./CofaceAGB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports